module.exports = __webpack_public_path__ + "assets/img/ability3.b32430af.png";